import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import * as bootstrap from 'bootstrap'
import App from './App.vue'
import store from './store'
import router from './router'
import i18n from './i18n'
import './services/axios/axiosGlobals'
import { makeServer } from './mock-api-server'
import { isDevSlowApiPreview, readDevApiLatencyMs } from './helpers/devApiLatency'
import Maintenance from './layouts/MaintenanceLayout.vue'

// Stop the browser restoring the scrolled Auth page Y onto Dashboard after
// router.replace (Agree → dashboard keeps the same history entry).
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

if (import.meta.env.MODE === 'mockapi') {
  makeServer()
  if (isDevSlowApiPreview()) {
    console.info(
      `[dev] API latency preview: ${readDevApiLatencyMs()}ms, requests are delayed; Vuex cache is still used on revisits`
    )
  }
}

if (import.meta.env.VITE_MAINTENANCE) {
  const app = createApp(Maintenance)
  app.provide(
    'rootSiteDomain',
    import.meta.env.MODE === 'production'
      ? 'https://www.swiftaid.co.uk'
      : 'https://swiftaid-co-uk.onrender.com'
  )
  app.use(i18n)
  app.mount('#app')
} else {
  const app = createApp(App)

  // Local dev and mock API runs should not report to Sentry (avoids 429 noise and quota use).
  if (import.meta.env.MODE === 'production') {
    Sentry.init({
      environment: import.meta.env.MODE,
      app,
      dsn: 'https://ab66cd10da7154e2c056d0a22074010e@o4508121914212352.ingest.de.sentry.io/4508121938526288',
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.browserProfilingIntegration(),
      ],
      tracesSampleRate: 0.2,
      profilesSampleRate: 1.0,
    })
  }

  app.provide(
    'rootSiteDomain',
    import.meta.env.MODE === 'production'
      ? 'https://www.swiftaid.co.uk'
      : 'https://swiftaid-co-uk.onrender.com'
  )

  app.config.globalProperties.$bootstrap = bootstrap
  app.provide('bootstrap', bootstrap)

  app.use(store)
  app.use(router)
  app.use(i18n)
  app.mount('#app')
}
